import React, { FC } from 'react';
import Form from 'components/Form';

import { AirWickPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Airwick: FC<AirWickPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Airwick;
